import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';
import React from 'react';

const GoverningLaw = () => {
  const sections = [
    {
      text: () => (
        <Box>
          <Typography>
            These Terms and Conditions are governed by and construed in
            accordance with the laws of the Federal Republic of Nigeria,
            including the Nigeria Data Protection Regulation (NDPR) where
            applicable, without regard to its conflict of law provisions.
          </Typography>
        </Box>
      ),
    },
    {
      text: () => (
        <Box>
          <Typography>
            <b>Dispute Resolution.</b> In the event of any dispute, controversy,
            or claim arising out of or relating to these Terms or the services
            provided by Topibro Technologies, the parties agree to first attempt
            to resolve the matter amicably through good-faith negotiations. If
            the dispute is not resolved within thirty (30) days of written
            notice by either party, the parties agree to submit the matter to
            arbitration in Lagos, Nigeria, under the Arbitration and
            Conciliation Act (Cap A18 LFN 2004) or any successor legislation.
            The arbitration award shall be final and binding.
          </Typography>
        </Box>
      ),
    },
    {
      text: () => (
        <Box>
          <Typography>
            <b>Jurisdiction.</b> Subject to the arbitration clause above, each
            party irrevocably submits to the exclusive jurisdiction of the
            courts located in Lagos State, Nigeria for any dispute or proceeding
            that cannot be resolved by arbitration. If any provision of these
            Terms is found to be unenforceable, the remaining provisions will
            continue in full force and effect.
          </Typography>
        </Box>
      ),
    },
    {
      text: () => (
        <Box>
          <Typography>
            <b>Changes to These Terms.</b> We reserve the right to revise these
            Terms at any time. We will notify users of significant changes by
            posting a notice on our website or via email. The updated Terms will
            be effective immediately upon posting. Your continued use of our
            services after any revision constitutes your acceptance of the new
            Terms. If you do not agree to the revised Terms, you must stop using
            our services.
          </Typography>
        </Box>
      ),
    },
    {
      text: () => (
        <Box>
          <Typography>
            <b>Contact Us.</b> If you have any questions about these Terms and
            Conditions, please contact us at: <b>info@topibrotech.com</b> or{' '}
            <b>+234 913 407 9164</b>. Our office is located at Topibro
            Technologies, Ijegun, Lagos, Nigeria.
          </Typography>
        </Box>
      ),
    },
  ];

  return (
    <Container sx={{ my: 10 }} id="governing-law">
      <Box sx={{ display: 'flex', justifyContent: 'center' }}>
        <Box sx={{ justifyContent: 'left' }}>
          <Typography
            variant="h4"
            sx={{ fontWeight: 600, textAlign: 'left', my: 2 }}
          >
            Governing Law & Dispute Resolution
          </Typography>
          {sections.map((section, i) => (
            <Typography
              key={i}
              variant="h6"
              sx={{
                fontWeight: 400,
                textAlign: 'left',
                my: 2,
                color: 'text.secondary',
              }}
            >
              {section.text()}
            </Typography>
          ))}
        </Box>
      </Box>
    </Container>
  );
};

export default GoverningLaw;
